
import { Component, Vue } from "vue-property-decorator";
import Axios from "axios";
import Constants from "@/constants";
import CommonUtils from "@/common-utils";
import firebase from "firebase/app";

declare type LoginForm = {
  id: string;
  password: string;
  loginType: string;
  appleUser: object;
};

@Component
export default class Login extends Vue {
  loginForm = { loginType: "email" } as LoginForm;
  isLoaded = false; // SNS버튼 한번만..
  // computed
  get loginSuccessRouterName(): string {
    return this.$route.params.toName || "Main"; // @Prop 으로 못가져옴
  }

  // method
  loginWithId(): void {
    if (!this.loginForm.id) {
      this.$toast(this.$t("login.a0006")); // 아이디를 입력해 주세요
      return;
    }
    if (!this.loginForm.password) {
      this.$toast(this.$t("login.a0007")); // 비밀번호를 입력해 주세요
      return;
    }

    Axios.post("/login", this.loginForm).then(this.onLoginSuccess);
  }

  onLoginSuccess(): void {
    CommonUtils.sendCommonEventLogs(this, firebase.analytics.EventName.LOGIN, { method: "" });

    sessionStorage.setItem(Constants.SESSION_LOGIN, "1");
    this.$store.commit("touchKeepAlive");
    if (window["ReactNativeWebView"]) {
      window["webViewBridge"].send("sessionChange", {}, null);
    }

    // 로그인 세션
    CommonUtils.setMemberInfoToSession().then((r) => {
      if (this.loginSuccessRouterName && this.loginSuccessRouterName != "Login") {
        this.$router.push({
          name: this.loginSuccessRouterName,
          params: this.$route.params,
        });
      } else {
        this.$router.push({ name: "Main" });
      }
    });
  }
  // 애플 로그인
  loginWith(provider: string): void {
    // SNS버튼 한번만..(빠르게 누르면 앱 첫 로그인 포인트 여러번 지급됨. 급하게 막음)
    if (this.isLoaded == true) {
      return;
    }

    this.isLoaded = true;

    const userAgent = navigator.userAgent.toLowerCase();
    if (window["ReactNativeWebView"] && userAgent.indexOf("iphone") > -1 && provider == "apple") {
      window["webViewBridge"].send("appleLogin", {}, this.callbackAppleLogin);
    } else {
      const url = process.env.VUE_APP_BASE_URL_API + `/oauth2/authorization/${provider}`;
      location.href = url;
    }
  }
  
  //네이티브 애플로그인 callback
  callbackAppleLogin(result: any): void {
    const params = { appleUser: result, loginType: "appSns" };

    Axios.post("/login", params).then(this.onLoginSuccess);
  }

  onApiSuccess(): void {
    Axios.get("/login/ping").then((r) => {
      if (r.data == "pong") {
        this.onLoginSuccess();
      }
    });
  }

  created() {
    this.$route.query.success && this.onApiSuccess();
  }
}
